export default __webpack_public_path__ + "static/media/alphaWhite.4059a549.svg";